<script>
export default {
	name: 'IconSvgXlsx',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.372 4.104C12.9073 4.10355 12.4617 3.92237 12.1331 3.60023C11.8045 3.27809 11.6197 2.8413 11.6193 2.38572V0H3.78736C3.18072 0 2.59892 0.23626 2.16996 0.656792C1.74099 1.07733 1.5 1.64768 1.5 2.2424V15.7602C1.5 16.3549 1.74099 16.9253 2.16996 17.3458C2.59892 17.7663 3.18072 18.0026 3.78736 18.0026H13.1884C13.795 18.0026 14.3768 17.7663 14.8058 17.3458C15.2347 16.9253 15.4757 16.3549 15.4757 15.7602V4.104H13.372Z"
				:fill="color" />
			<path
				d="M15.4757 4.104H13.372C12.9073 4.10355 12.4617 3.92237 12.1331 3.60023C11.8045 3.27809 11.6197 2.8413 11.6193 2.38572V0L15.4757 4.104Z"
				fill="#58B857" />
			<path
				d="M17.1349 14.2169H6.50646C5.75254 14.2169 5.14136 14.8161 5.14136 15.5552V18.6617C5.14136 19.4008 5.75254 20 6.50646 20H17.1349C17.8888 20 18.5 19.4008 18.5 18.6617V15.5552C18.5 14.8161 17.8888 14.2169 17.1349 14.2169Z"
				fill="#58B857" />
			<path d="M7.77201 17.7496V18.3554H7.13196V17.7496H7.77201Z" fill="#FFFFFF" />
			<path
				d="M9.64463 18.3556L9.1066 17.5756L8.64335 18.3556H7.93529L8.75213 17.0656L7.90979 15.8499H8.64335L9.16779 16.6048L9.62 15.8499H10.3246L9.51883 17.1115L10.379 18.3556H9.64463Z"
				fill="#F3F3F6" />
			<path
				d="M13.9339 18.0246C13.8606 18.1396 13.7553 18.2318 13.6305 18.2904C13.4785 18.3601 13.312 18.3941 13.1443 18.3895C12.8912 18.3999 12.6418 18.3275 12.4354 18.1837C12.344 18.1165 12.2693 18.03 12.2168 17.9306C12.1643 17.8312 12.1352 17.7215 12.1319 17.6096H12.7898C12.7945 17.694 12.8312 17.7736 12.8927 17.8329C12.9539 17.8888 13.0351 17.9188 13.1188 17.9162C13.1528 17.9182 13.187 17.9135 13.2192 17.9025C13.2515 17.8915 13.2812 17.8744 13.3066 17.8521C13.3293 17.8305 13.3471 17.8045 13.359 17.7759C13.3708 17.7472 13.3764 17.7163 13.3755 17.6854C13.3763 17.656 13.3711 17.6268 13.3601 17.5994C13.3492 17.5721 13.3327 17.5472 13.3117 17.5262C13.2667 17.4816 13.2133 17.4459 13.1545 17.4213C13.0927 17.3946 13.006 17.3621 12.8944 17.3237C12.7589 17.28 12.6266 17.2274 12.4983 17.1663C12.3928 17.113 12.3023 17.0352 12.2348 16.9396C12.1563 16.8239 12.1176 16.6867 12.1243 16.548C12.1212 16.4105 12.1616 16.2754 12.2399 16.1613C12.3203 16.0498 12.4314 15.9631 12.5603 15.9113C12.7089 15.8521 12.8684 15.8237 13.0287 15.828C13.2721 15.8148 13.5125 15.8853 13.7087 16.0271C13.7922 16.0937 13.8605 16.1767 13.9094 16.2706C13.9583 16.3646 13.9866 16.4676 13.9926 16.5729H13.3236C13.3162 16.4992 13.2839 16.43 13.2318 16.3763C13.2052 16.3513 13.1737 16.3319 13.1392 16.3193C13.1047 16.3067 13.068 16.3011 13.0312 16.303C12.9675 16.3001 12.9049 16.3203 12.8553 16.3596C12.8324 16.3809 12.8146 16.4069 12.8031 16.4357C12.7916 16.4645 12.7868 16.4954 12.789 16.5263C12.7877 16.5823 12.8091 16.6365 12.8485 16.6771C12.8908 16.7204 12.9417 16.7547 12.9981 16.7779C13.0584 16.8038 13.1451 16.8371 13.2582 16.8771C13.3961 16.9212 13.5305 16.9752 13.6602 17.0388C13.7662 17.0948 13.8575 17.1741 13.9271 17.2704C14.0064 17.388 14.0457 17.5271 14.0393 17.6679C14.0382 17.794 14.0017 17.9174 13.9339 18.0246Z"
				fill="#F3F3F6" />
			<path d="M11.1578 17.8914H11.9856V18.3556H10.5406V15.8499H11.1595L11.1578 17.8914Z" fill="#F3F3F6" />
			<path
				d="M15.7758 18.3905L15.2368 17.6105L14.7736 18.3905H14.0655L14.8824 17.1005L14.04 15.8848H14.7736L15.298 16.6397L15.7502 15.8848H16.4549L15.6491 17.1464L16.5093 18.3905H15.7758Z"
				fill="#F3F3F6" />
			<path
				d="M11.6057 12.5695H5.37349C4.83374 12.5695 4.39429 12.0428 4.39429 11.3945V6.96221C4.39429 6.31474 4.83374 5.78809 5.37349 5.78809H11.6082C12.1471 5.78809 12.5866 6.31474 12.5866 6.96221V11.3945C12.584 12.0428 12.1446 12.5695 11.6057 12.5695ZM5.37349 6.38806C5.10914 6.38806 4.89495 6.64556 4.89495 6.96221V11.3945C4.89495 11.7112 5.10914 11.9687 5.37349 11.9687H11.6082C11.8717 11.9687 12.0859 11.7112 12.0859 11.3945V6.96221C12.0859 6.64556 11.8717 6.38806 11.6082 6.38806H5.37349Z"
				fill="#58B857" />
			<path d="M12.3342 9.90039H4.64258V10.5012H12.3342V9.90039Z" fill="#58B857" />
			<path d="M12.3342 7.84045H4.64258V8.44126H12.3342V7.84045Z" fill="#58B857" />
			<path d="M10.3638 6.08813H9.75098V12.2687H10.3638V6.08813Z" fill="#58B857" />
			<path d="M7.22479 6.08813H6.61194V12.2687H7.22479V6.08813Z" fill="#58B857" />
		</svg>
	</div>
</template>

<style scoped>

</style>